import React from "react";
import { QueryRenderer, graphql } from "react-relay";
import environment from "../AuthEnv";
import ToggleBookmark from "./ToggleBookmark";

const userBookmarkQuery = graphql`
	query ToggleBookmarkContainerQuery($id: ID!, $post: ID) {
		post(id: $id) {
			...ToggleBookmark_user_Bookmark @arguments(post: $post)
		}
	}
`;

function ToggleBookmarkContainer(props) {
	const settings = props.settings;
	const user = props.user;
	const { userId } = props.settings;
	const postId = props.postId;
	// const isBookmarked = props.isBookmarked;
	// const setIsBookmarked = props.setIsBookmarked;

	// console.log("user: " + userId);
	// console.log("post: " + postId);

	return (
		<QueryRenderer
			environment={environment}
			query={userBookmarkQuery}
			variables={{ id: postId, post: postId }}
			render={({ error, props }) => {
				if (error) {
					return <div>Error!</div>;
				}
				if (!props) {
					return <div></div>;
				}
				return (
					<>
						<ToggleBookmark
							postId={postId}
							settings={settings}
							user={user}
							user_Bookmark={props.post}
						/>
					</>
				);
			}}
		/>
	);
}

export default ToggleBookmarkContainer;
